'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path');
const _ = require('lodash');

const proHash = {
  StarCharge: {
    name: 'starcharge',
    // buildApi: 'http://10.8.8.6:8005/webApi',
    // proApi: 'https://app.starcharge.com/webApi',
    // devApi: 'http://10.8.58.23:8005/webApi',
    proApiV2: "https://gateway.starcharge.com/apph5/webApiV2",
    // buildApiV2: 'http://app.dev.k8s.star-charge.com/webApiV2',  // 开发环境
    buildApiV2: "https://test-api-gateway.starcharge.com/apph5/webApiV2", // 测试环境
    testApiV2: "https://test-api-gateway.starcharge.com/apph5/webApiV2", // 测试环境
    // devApiV2: "http://10.8.58.23:8005/webApiV2", // 王玖侠
    // devApiV2: "http://dev-api-gateway.starcharge.com/apph5/webApiV2", // 开发环境
    devApiV2: "https://test-api-gateway.starcharge.com/apph5/webApiV2", // 测试环境
    // devOriginUrl: 'http://10.8.8.8:8005',//内网跳转后台页面（木有前后端分离）地址
    devOriginUrl: 'http://app.k8s.star-charge.com',//内网跳转后台页面（木有前后端分离）地址
    proOriginUrl: 'https://app.starcharge.com',//外网跳转后台页面（木有前后端分离）地址
    buildApi: 'https://gatewaycloudtest.starcharge.com/apph5/webApi',
    proApi: 'https://gateway.starcharge.com/apph5/webApi',    // 分享接口
    activeApi: process.isPublic ? 'http://10.9.35.53:8004/webApi' : 'https://828-console.starcharge.com/webApi',//暂时无用
    devApi: 'https://gatewaycloudtest.starcharge.com/apph5/webApi',
    // devApi: 'http://10.8.8.67:8005/webApi',  // 郭
    // devApi: 'http://10.8.8.220:8027/webApi',  // 许
    // devApi: 'http://10.8.8.176:8005/webApi',  // 徐
    // devApi: 'http://lottyactivity-zyy.aiyang.club:8080/webApi',  // 赵洋洋
    staticPathName: 'starCharge',
    // devWebUrl: 'http://10.8.11.85:8080/#',
    devWebUrl: 'http://apph5.test.ccchong.com:8086/#',//内网跳转H5地址
    beeAppUrlApi: 'http://test-app-datacollection.starcharge.cloud',//内网小蜜蜂认证
    beeAppUrlOutApi: 'https://app-datacollection.starcharge.com',//外网网小蜜蜂认证
    // beeAppUrlApi: 'http://10.253.255.52:8088',//内网小蜜蜂认证
    // devWebUrl: 'http://app-cdn.starcharge.com/wapTest/index.html#',
    proWebUrl: 'https://app-cdn.starcharge.com/wap/index.html#',//外网跳转H5地址
    // devOriginUrl: 'http://api-gateway.test.ccchong.com:8086',//内网跳转后台页面（木有前后端分离）地址
    // proOriginUrl: 'https://gateway.starcharge.com',//外网跳转后台页面（木有前后端分离）地址
    shenceUrl: 'https://event-data.starcharge.com/sa',//神策埋点
    // luckDrawApi: 'http://lottyactivity.test.k8s.star-charge.com/api',//抽奖活动  内网后台地址
    // luckDrawApi: 'http://10.8.39.181:8040/api',  // 郭
    // luckDrawApi: 'http://10.8.9.38:8040/api',  // 许
    // luckDrawApi: 'http://web1.aiyang.club:8080/api',  //赵
    // luckDrawApi: 'http://10.253.255.38:8040/api',  // 杨
    // luckDrawApiNewPoint: 'http://10.253.255.38:8040/api.V2',  // 杨
    // luckDrawApi: 'http://10.253.255.67:8088/api',  //赵yy
    // luckDrawApi: 'http://10.8.9.105:8040/api',  // 王
    // luckDrawApi: 'http://10.8.10.122:8040/api',  // 🐯
    // luckDrawApiNewPoint: 'http://10.253.255.38:8041/api.V2',  //赵yy
    luckDrawApi: 'https://gatewaycloudtest.starcharge.com/activity/apiV2',  // 抽奖活动  内网后台地址
    luckDrawApiOut: 'https://gateway.starcharge.com/activity/apiV2',// 抽奖活动  外网后台地址
    luckDrawApiNewPoint: 'https://gatewaycloudtest.starcharge.com/activity/api.V2',  // 抽奖活动  .V2内网后台地址
    // luckDrawApiNewPoint: 'http://10.8.58.23:8005/api.V2',  // 玖侠
    // luckDrawApiNewPoint: 'http://10.8.60.2:8040/api.V2',  // 许文炜
    // luckDrawApiNewPoint: 'http://10.8.58.208:8040/api.V2',  // 王星齐
    luckDrawApiNewPointOut: 'https://gateway.starcharge.com/activity/api.V2',// 抽奖活动  外网后台地址  .V2请求地址。
    // luckDrawApi: 'https://lottyactivitycloudtest.starcharge.com/api',  // 抽奖活动  内网后台地址（https）
    paymentUrl: 'http://test-lottyactivity.starcharge.cloud/redirect.do', // 微信支付跳转内网后台地址
    paymentUrlOut: 'https://lotty-backend.starcharge.com/redirect.do', // 微信支付跳转外网后台地址
    activityUrlDev: 'http://app-cdn.starcharge.com/wapActivity',
    activityUrlPro: 'https://activity-h5.starcharge.com/activitys',
    sandBoxApiV2: "http://api-gateway-sandbox.starcharge.cloud/apph5/webApiV2",
    sandBoxApi: 'http://api-gateway.sandbox.ccchong.com:8086/apph5/webApi',
    sandBoxLuckDrawApi: 'http://lottyactivity.sandbox.ccchong.com/api',
  },
  MemberCenter: {
    name: 'MemberCenter',
    api: 'http://www.me2u.com.cn/xxgmc',
    devApi: 'http://www.me2u.com.cn/xxgmc',
    basePath: 'http://www.me2u.com.cn/MemberCenter/'
  },
  DHBX: {
    name: 'dhbaoxian',
    buildApi: 'http://10.8.8.8:8034/api', // 内网打包接口地址
    proApi: 'https://dhbx.starcharge.com/api', // 外网打包接口地址
    devApi: 'http://10.8.8.8:8034/api', // 本地测试接口地址
    udApi: 'http://10.8.8.8:8034', // 内网图片上传地址
    proUdApi: 'https://dhbx.starcharge.com', // 外网图片上传地址
    devWebUrl: 'http://dhbxweb.dev.star-charge.com', //内网项目地址
    proWebUrl: 'http://web.dhbaoxian.com', // 外网项目地址
    staticPathName: 'dhbaoxian'
  },
  DHWRAP: {
    name: 'dhwrap',
    buildApi: 'http://dhbx.test.ccchong.com:8081/api', // 内网打包接口地址
    proApi: 'https://dhbx.starcharge.com/api', // 外网打包接口地址
    devApi: 'http://10.8.8.8:8034/api', // 本地测试接口地址
    udApi: 'http://10.8.8.8:8034', // 内网图片上传地址
    proUdApi: 'https://dhbx.starcharge.com', // 外网图片上传地址
    devWebUrl: 'http://dhbxweb.dev.star-charge.com', //内网项目地址
    proWebUrl: 'http://h5.dhbaoxian.com', // 外网项目地址
    staticPathName: 'dhwrap'
  },
  VICIPIXI: {
    name: 'vcpixi'
  },
  BUICK: {
    name: 'buick',
    buildApi: 'http://wechat.test.ccchong.com:8086/',
    proApi: 'https://wx.starcharge.com/',
    devApi: 'http://10.8.8.85:8010',
    staticPathName: 'buick'
  }
};

const project = proHash.StarCharge;

console.log('项目配置信息', project);

// 配置项目名称
const projectName = project.name;

// 配置发布环境api
const buildApi = project.buildApi;
const buildApiV2 = project.buildApiV2;
const sandBoxApi = project.sandBoxApi;
const sandBoxApiV2 = project.sandBoxApiV2;
const sandBoxLuckDrawApi = project.sandBoxLuckDrawApi;
const proApi = project.proApi;
const proApiV2 = project.proApiV2;
const activeApi = project.activeApi;
const shenceUrl = project.shenceUrl;
const devOriginUrl = project.devOriginUrl;
const proOriginUrl = project.proOriginUrl;
const paymentUrl = project.paymentUrl;
const paymentUrlOut = project.paymentUrlOut;
const activityUrlDev = project.activityUrlDev;
const activityUrlPro = project.activityUrlPro;

// 配置开发环境代理api
const devApi = project.devApi;
const devApiV2 = project.devApiV2;

const udApi = project.udApi;
const proUdApi = project.proUdApi;
const luckDrawApi = project.luckDrawApi;
const luckDrawApiOut = project.luckDrawApiOut;
const luckDrawApiNewPoint = project.luckDrawApiNewPoint;
const luckDrawApiNewPointOut = project.luckDrawApiNewPointOut;
const beeAppUrlApi = project.beeAppUrlApi;
const beeAppUrlOutApi = project.beeAppUrlOutApi;


// 配置发布环境静态资源地址
const basePath = project.basePath;

// 项目地址
const devWebUrl = project.devWebUrl;
const proWebUrl = project.proWebUrl;

// 静态文件地址
const staticPathName = project.staticPathName;

module.exports = {
  activityUrlDev,
  activityUrlPro,
  projectName,
  buildApi,
  buildApiV2,
  sandBoxApi,
  sandBoxApiV2,
  sandBoxLuckDrawApi,
  proApi,
  proApiV2,
  activeApi,
  devApi,
  devApiV2,
  basePath,
  udApi,
  shenceUrl,
  devOriginUrl,
  proOriginUrl,
  proUdApi,
  devWebUrl,
  proWebUrl,
  beeAppUrlApi,
  beeAppUrlOutApi,
  luckDrawApi,
  luckDrawApiOut,
  luckDrawApiNewPoint,
  luckDrawApiNewPointOut,
  paymentUrl,
  paymentUrlOut,
  dev: {
    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {
      '/luck': {
        target: luckDrawApi,
        changeOrigin: true,
        pathRewrite: {'^/luck': ''}
      },
      '/newLuckPoint': {
        target: luckDrawApiNewPoint,
        changeOrigin: true,
        pathRewrite: {'^/newLuckPoint': ''}
      },
      '/api': {
        target: devApi,
        changeOrigin: true,
        pathRewrite: {'^/api': ''}
      },
      "/webApiV2": {
        target: devApiV2,
        changeOrigin: true,
        pathRewrite: { "^/webApiV2": "" }
      },
      '/ud': {
        target: udApi,
        changeOrigin: true,
        pathRewrite: {'^/ud': ''}
      },
      '/bee': {
        target: beeAppUrlApi,
        changeOrigin: true,
        pathRewrite: {'^/bee': ''}
      },
    },
    // Various Dev Server settings
    host: '0.0.0.0', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: false,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../output/' + projectName + '/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../output/' + projectName),
    assetsSubDirectory: 'static/' + staticPathName,
    assetsPublicPath: '',
    assetsFromDirectory: staticPathName,

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



// WEBPACK FOOTER //
// ./config/index.js